Vue.component('public-campaign-list', require('./PublicCampaignList').default);
Vue.component('public-campaign-form', require('./PublicCampaignForm').default);
Vue.component('sms-preference-form', require('./SmsPreferenceForm').default);
Vue.component('email-preference-form', require('./EmailPreferenceForm').default);

Vue.component('cx-campaign-list', require('./CxCampaignList.vue').default);
Vue.component('cx-campaign-list-item', require('./CxCampaignListItem.vue').default);
Vue.component('cx-campaign-form', require('./CxCampaignForm.vue').default);

Vue.component('nps-campaign-list', require('./NpsCampaignList.vue').default);
Vue.component('nps-campaign-list-item', require('./NpsCampaignListItem.vue').default);
Vue.component('nps-campaign-form', require('./NpsCampaignForm.vue').default);

Vue.component('message-template-selector', require('./MessageTemplateSelector.vue').default);
require('./workflow');

Vue.component('campaign-metrics', require('./CampaignMetrics').default);
Vue.component('public-campaign-list-item', require('./PublicCampaignListItem.vue').default);

Vue.component('campaign-settings', require('./CampaignSettings').default);

Vue.component('follow-up', require('./FollowUp').default);

require('./previews');
